import {
  LOAD_KPI_CONFIG,
  RESET_KPI_CONFIG,
  SET_KPI_METRIC_GOAL_ACTION,
  LoadKpiConfigAction,
  ResetKpiConfigAction,
  FetchKpiConfigPayload,
  SetKpiMetricGoalAction,
  SetKpiMetricGoalPayload,
} from "./KpiConfigTypes";

export const loadKpiConfig = (
  payload: FetchKpiConfigPayload,
): LoadKpiConfigAction => {
  return {
    type: LOAD_KPI_CONFIG,
    payload,
  };
};

export const resetKpiConfig = (): ResetKpiConfigAction => {
  return {
    type: RESET_KPI_CONFIG,
  };
};

export const setKpiMetricGoal = (
  payload: SetKpiMetricGoalPayload,
): SetKpiMetricGoalAction => {
  return {
    type: SET_KPI_METRIC_GOAL_ACTION,
    payload,
  };
};
